module.exports = "../../static/img/logo-symbol.950bc15.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-symbol.png
// module id = 1308
// module chunks = 2